import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '@/components/ui/Dialog/Dialog'
import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle
} from '@/ui/components/drawer'
import { Button } from '@/components/ui/Button/Button'
import { useMediaQuery } from '@/hooks/useMediaQuery'
import { formatPhoneNumber } from '@/utils/phone.utils'

type NetworkConnectionAlertProps = {
  isOpen: boolean
  onClose: () => void
  interlocutor: {
    firstName: string
    phone?: string | null
  }
}

type AlertContentProps = {
  interlocutor: NetworkConnectionAlertProps['interlocutor']
  onCall: () => void
  onClose: () => void
  /** Use 'drawer' for mobile (stacked buttons), 'dialog' for desktop (buttons in row) */
}

function AlertContent({ interlocutor, onCall, onClose }: AlertContentProps) {
  return (
    <>
      {interlocutor.phone && (
        <Button
          variant="default"
          onClick={onCall}
          className="w-full bg-primary text-white hover:opacity-90 rounded-lg"
        >
          Appeler le {formatPhoneNumber(interlocutor.phone)}
        </Button>
      )}
      <Button
        onClick={onClose}
        className="w-full bg-gray-100 text-gray-900 rounded-lg hover:bg-gray-200"
      >
        Fermer
      </Button>
    </>
  )
}

export function NetworkConnectionAlert({ isOpen, onClose, interlocutor }: NetworkConnectionAlertProps) {
  const isMobile = useMediaQuery('(max-width: 639px)')

  const handleCall = () => {
    if (interlocutor.phone) {
      const normalizedPhone = interlocutor.phone.replace(/^\+/, '')
      window.location.href = `tel:+${normalizedPhone}`
    }
  }

  if (isMobile) {
    return (
      <Drawer open={isOpen} onOpenChange={(open: boolean) => !open && onClose()}>
        <DrawerContent className="max-w-md mx-auto">
          <DrawerHeader className="text-left pt-0">
            <DrawerTitle className="text-lg font-semibold">
              Problème de connexion ?
            </DrawerTitle>
            <DrawerDescription className="pt-2 text-left text-primary font-light">
              Appelez {interlocutor.firstName} sur son numéro personnel et continuez l&apos;appel
            </DrawerDescription>
          </DrawerHeader>
          <DrawerFooter className="flex flex-col gap-3 pt-4">
            <AlertContent
              interlocutor={interlocutor}
              onCall={handleCall}
              onClose={onClose}
            />
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    )
  }

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="text-lg font-semibold text-left">
            Problème de connexion ?
          </DialogTitle>
          <DialogDescription className="pt-2 text-left text-primary font-light">
            Appelez {interlocutor.firstName} sur son numéro personnel et continuez l&apos;appel
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex-col gap-3 pt-4">
          <div className="flex flex-col w-full gap-3 my-2">
            <AlertContent
              interlocutor={interlocutor}
              onCall={handleCall}
              onClose={onClose}
            />
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
